import { AssetfiAssetType } from '@/types/asset-type';

export default function WarningSvg({ width = 24, height = 24 }: AssetfiAssetType) {
  return (
    <svg width={width} height={height} viewBox="0 0 21 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.5728 6.70582V10.7058M10.5728 13.7058V13.7158M3.88554 17.7058H17.2601C18.7651 17.7058 19.7309 16.1061 19.0299 14.7743L12.3426 2.06851C11.5928 0.643833 9.5528 0.643829 8.80297 2.06851L2.1157 14.7743C1.41474 16.1061 2.38052 17.7058 3.88554 17.7058Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
